// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/RelationModal/RelationModal.css */

.relation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.relation-modal {
  background: white;
  border-radius: 12px;
  width: 420px;
  max-width: 90vw;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.relation-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.relation-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.relation-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.relation-modal-header .close-btn:hover {
  color: #111827;
}

.relation-modal-parties {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  background: #f3f4f6;
}

.relation-modal-parties .party {
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
}

.relation-modal-parties .individual {
  background: #dbeafe;
  color: #1e40af;
}

.relation-modal-parties .entity {
  background: #fef3c7;
  color: #92400e;
}

.relation-modal-parties .arrow {
  color: #9ca3af;
  font-size: 18px;
}

.relation-modal form {
  padding: 20px;
}

.relation-section {
  margin-bottom: 20px;
}

.section-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

.role-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.role-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.role-option:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.role-option.selected {
  border-color: #3b82f6;
  background: #eff6ff;
}

.role-option input[type="radio"] {
  margin-top: 2px;
  accent-color: #3b82f6;
}

.role-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.role-label {
  font-weight: 500;
  color: #111827;
  font-size: 14px;
}

.role-description {
  font-size: 12px;
  color: #6b7280;
}

.relation-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.relation-field {
  flex: 1 1;
}

.relation-field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.relation-field input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.relation-field input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.input-with-suffix {
  position: relative;
  display: flex;
  align-items: center;
}

.input-with-suffix input {
  padding-right: 36px;
}

.input-with-suffix .suffix {
  position: absolute;
  right: 12px;
  color: #6b7280;
  font-size: 14px;
}

.error-message {
  color: #dc2626;
  font-size: 13px;
  margin: 0 0 16px 0;
  padding: 10px 12px;
  background: #fef2f2;
  border-radius: 6px;
}

.relation-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.relation-modal-actions button {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-cancel {
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
}

.btn-cancel:hover {
  background: #f3f4f6;
}

.btn-confirm {
  background: #3b82f6;
  border: 1px solid #3b82f6;
  color: white;
}

.btn-confirm:hover {
  background: #2563eb;
}

/* Remuneration banner */
.remuneration-banner {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.remuneration-banner.has-remuneration {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
}

.remuneration-banner.no-remuneration {
  background: #fef3c7;
  border: 1px solid #fcd34d;
}

.remuneration-banner.dividends-only {
  background: #eff6ff;
  border: 1px solid #93c5fd;
}

.remuneration-banner .banner-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.remuneration-banner .banner-content {
  flex: 1 1;
}

.remuneration-banner .banner-content strong {
  display: block;
  font-size: 14px;
  color: #111827;
  margin-bottom: 4px;
}

.remuneration-banner .banner-content p {
  font-size: 13px;
  color: #4b5563;
  margin: 0;
  line-height: 1.4;
}

.remuneration-banner .banner-content .banner-detail {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}

/* Entity type badge */
.entity-type-badge {
  display: inline-block;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 8px;
  vertical-align: middle;
}

/* Dividend section */
.dividend-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.dividend-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.checkbox-option input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #f59e0b;
  cursor: pointer;
}

.checkbox-label {
  font-size: 14px;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.checkbox-hint {
  cursor: help;
  font-size: 12px;
  opacity: 0.7;
}

.dispense-option {
  margin-left: 28px;
  padding: 8px 12px;
  background: #fef3c7;
  border-radius: 6px;
  border: 1px solid #fcd34d;
}

.dispense-option .checkbox-label {
  font-size: 13px;
  color: #92400e;
}

/* Info tooltip in dispense option */
.info-tooltip {
  cursor: help;
  font-size: 12px;
  margin-left: 4px;
  position: relative;
}

.info-tooltip:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 400;
  white-space: normal;
  width: 220px;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  margin-bottom: 6px;
}

.dividend-info {
  margin-top: 12px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  font-size: 12px;
  color: #0369a1;
  border: 1px solid #bae6fd;
}

.dividend-info-simple {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 16px 0;
  padding: 8px 12px;
  background: #f9fafb;
  border-radius: 6px;
}

/* Fiscal option section */
.fiscal-option-section {
  margin-bottom: 16px;
}

.fiscal-options {
  display: flex;
  gap: 10px;
}

.fiscal-option {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.fiscal-option:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.fiscal-option.selected {
  border-color: #f59e0b;
  background: #fffbeb;
}

.fiscal-option input[type="radio"] {
  margin-top: 2px;
  accent-color: #f59e0b;
}

.fiscal-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fiscal-label {
  font-weight: 500;
  color: #111827;
  font-size: 13px;
}

.fiscal-description {
  font-size: 11px;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/components/RelationModal/RelationModal.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* src/components/RelationModal/RelationModal.css */\n\n.relation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.relation-modal {\n  background: white;\n  border-radius: 12px;\n  width: 420px;\n  max-width: 90vw;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.relation-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.relation-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.relation-modal-header .close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.relation-modal-header .close-btn:hover {\n  color: #111827;\n}\n\n.relation-modal-parties {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  background: #f3f4f6;\n}\n\n.relation-modal-parties .party {\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.relation-modal-parties .individual {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.relation-modal-parties .entity {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.relation-modal-parties .arrow {\n  color: #9ca3af;\n  font-size: 18px;\n}\n\n.relation-modal form {\n  padding: 20px;\n}\n\n.relation-section {\n  margin-bottom: 20px;\n}\n\n.section-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 10px;\n}\n\n.role-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.role-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.role-option:hover {\n  border-color: #d1d5db;\n  background: #f9fafb;\n}\n\n.role-option.selected {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.role-option input[type=\"radio\"] {\n  margin-top: 2px;\n  accent-color: #3b82f6;\n}\n\n.role-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.role-label {\n  font-weight: 500;\n  color: #111827;\n  font-size: 14px;\n}\n\n.role-description {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.relation-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.relation-field {\n  flex: 1;\n}\n\n.relation-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.relation-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.relation-field input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.input-with-suffix {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-with-suffix input {\n  padding-right: 36px;\n}\n\n.input-with-suffix .suffix {\n  position: absolute;\n  right: 12px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.error-message {\n  color: #dc2626;\n  font-size: 13px;\n  margin: 0 0 16px 0;\n  padding: 10px 12px;\n  background: #fef2f2;\n  border-radius: 6px;\n}\n\n.relation-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.relation-modal-actions button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.btn-cancel {\n  background: white;\n  border: 1px solid #d1d5db;\n  color: #374151;\n}\n\n.btn-cancel:hover {\n  background: #f3f4f6;\n}\n\n.btn-confirm {\n  background: #3b82f6;\n  border: 1px solid #3b82f6;\n  color: white;\n}\n\n.btn-confirm:hover {\n  background: #2563eb;\n}\n\n/* Remuneration banner */\n.remuneration-banner {\n  display: flex;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.remuneration-banner.has-remuneration {\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n}\n\n.remuneration-banner.no-remuneration {\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n}\n\n.remuneration-banner.dividends-only {\n  background: #eff6ff;\n  border: 1px solid #93c5fd;\n}\n\n.remuneration-banner .banner-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.remuneration-banner .banner-content {\n  flex: 1;\n}\n\n.remuneration-banner .banner-content strong {\n  display: block;\n  font-size: 14px;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.remuneration-banner .banner-content p {\n  font-size: 13px;\n  color: #4b5563;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.remuneration-banner .banner-content .banner-detail {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Entity type badge */\n.entity-type-badge {\n  display: inline-block;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n/* Dividend section */\n.dividend-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.dividend-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.checkbox-option input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #f59e0b;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  font-size: 14px;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.checkbox-hint {\n  cursor: help;\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n.dispense-option {\n  margin-left: 28px;\n  padding: 8px 12px;\n  background: #fef3c7;\n  border-radius: 6px;\n  border: 1px solid #fcd34d;\n}\n\n.dispense-option .checkbox-label {\n  font-size: 13px;\n  color: #92400e;\n}\n\n/* Info tooltip in dispense option */\n.info-tooltip {\n  cursor: help;\n  font-size: 12px;\n  margin-left: 4px;\n  position: relative;\n}\n\n.info-tooltip:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1e293b;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 400;\n  white-space: normal;\n  width: 220px;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  margin-bottom: 6px;\n}\n\n.dividend-info {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background: #f0f9ff;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #0369a1;\n  border: 1px solid #bae6fd;\n}\n\n.dividend-info-simple {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 16px 0;\n  padding: 8px 12px;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n/* Fiscal option section */\n.fiscal-option-section {\n  margin-bottom: 16px;\n}\n\n.fiscal-options {\n  display: flex;\n  gap: 10px;\n}\n\n.fiscal-option {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.fiscal-option:hover {\n  border-color: #d1d5db;\n  background: #f9fafb;\n}\n\n.fiscal-option.selected {\n  border-color: #f59e0b;\n  background: #fffbeb;\n}\n\n.fiscal-option input[type=\"radio\"] {\n  margin-top: 2px;\n  accent-color: #f59e0b;\n}\n\n.fiscal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.fiscal-label {\n  font-weight: 500;\n  color: #111827;\n  font-size: 13px;\n}\n\n.fiscal-description {\n  font-size: 11px;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
